exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".footer-explain-page .daishu-bottom-logo[data-v-4426181e]{text-align:center;font-size:.12rem;color:#919191}.footer-explain-page .daishu-bottom-logo .daishu-logo[data-v-4426181e]{padding-bottom:.0375rem}.footer-explain-page .daishu-bottom-logo .tip[data-v-4426181e]{padding-bottom:.025rem;color:#118eea}.footer-explain-page .daishu-bottom-logo a[data-v-4426181e]{color:#999}", ""]);

// exports
